module.exports = __webpack_public_path__ + "static/media/cancel-icon.68f240c9.svg";